import React, { useState } from 'react';
import './BannerMfd.css';

import bannerimage from '../assets/images/dashboard-image.webp';
import demoVideo from '../../src/assets/images/video.mp4';

const BannerMfd = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);

  const handleWatchDemo = (e) => {
    e.preventDefault();
    setShowVideoModal(true);
  };

  const handleCloseModal = () => {
    setShowVideoModal(false);
  };

  return (
    <>
      {/* HERO */}
      <section className="hero" id="home">
        <div className="hero-canvas">
          <div className="grid-bg"></div>
          <div className="blob1"></div>
          <div className="blob2"></div>
          <div className="blob3"></div>
        </div>

        <h1 className="hero-h1">
          <span className="line1">Sales Ninja</span>
          <p>
            <span className="line2">AI-optimized Lead Management </span>
          </p>
          <span className="line3"> MFD CRM</span>
        </h1>

        <div className="hero-acts">
          <a href="/#contactus" className="btn-big-ghost">
            Book Free Demo
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M2 7h10M8 3l4 4-4 4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>

          <a
            href="#!"
            className="btn-big copenModal"
            dataid="watchdata"
            onClick={handleWatchDemo}
          >
            Watch the Demo
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M2 7h10M8 3l4 4-4 4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>

        <h3 className="hero-sub">Built for MFDs who want: </h3>

        <div className="hero-trust" style={{ marginTop: '15px' }}>
          <div className="trust-bullets">
            <div className="trust-pill">
              <span className="trust-pill-dot"></span> More Conversions
            </div>

            <div className="trust-pill">
              <span className="trust-pill-dot"></span> Better Follow-ups
            </div>

            <div className="trust-pill">
              <span className="trust-pill-dot"></span> Clear Pipeline Visibility
            </div>

            <div className="trust-pill">
              <span className="trust-pill-dot"></span> Less Manual Work
            </div>
          </div>
        </div>

        {/* DASHBOARD MOCK */}
        <div className="hero-dash-wrap rev">
          <div className="browser-frame">
            <img src={bannerimage} alt="dashboard" style={{ width: '100%' }} />
          </div>
        </div>
      </section>

      {/* VIDEO MODAL */}
      {showVideoModal && (
        <div className="sn-video-modal">
          <div className="sn-video-overlay" onClick={handleCloseModal}></div>

          <div className="sn-video-box">
            <button
              type="button"
              className="sn-video-close"
              onClick={handleCloseModal}
            >
              ×
            </button>

            <video
              className="sn-demo-video"
              controls
              autoPlay
              muted
              playsInline
            >
              <source src={demoVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </>
  );
};

export default BannerMfd;